export default __webpack_public_path__ + "static/media/page1-img_04.5fa28207.jpg";